// src/brand/brands.js
// Per-brand chrome for the multi-jurisdiction site. BoardWatch (school boards)
// and CityWatch (city councils / boards of supervisors) share one React app;
// the active brand is chosen by route (/city-watch => citywatch) or by the
// district being viewed (Districts.brand_slug / entity_type). See BrandContext.
import defaultLogo from "../assets/logo.png";

export const BRANDS = {
  boardwatch: {
    slug: "boardwatch",
    name: "BoardWatch",
    logoSrc: defaultLogo,
    logoAlt: "BoardWatch Logo",
    tagline: "Turn public board meetings into searchable, citation-backed insights.",
    mailto: "boardwatch.ai@gmail.com",
    demoPath: "/districts/suhsd",
    demoLabel: "Live Demo",
    homePath: "/",
    title: "BoardWatch: AI-Powered School Board Transparency",
    description:
      "Browse meetings, topics, voting records, and elections for school districts.",
  },
  citywatch: {
    slug: "citywatch",
    name: "CityWatch",
    // TODO(design): swap for a dedicated src/assets/logo-citywatch.png wordmark.
    logoSrc: defaultLogo,
    logoAlt: "CityWatch Logo",
    tagline: "Turn city council meetings into searchable, citation-backed insights.",
    mailto: "boardwatch.ai@gmail.com",
    demoPath: "/districts/sfbos",
    demoLabel: "Live Demo",
    homePath: "/city-watch",
    title: "CityWatch: AI-Powered City Council Transparency",
    description:
      "Browse meetings, topics, and voting records for city councils and boards of supervisors.",
  },
};

export const DEFAULT_BRAND = "boardwatch";

// Resolve a brand slug from a Districts row (used by dashboard pages).
export function brandSlugForDistrict(d) {
  if (!d) return DEFAULT_BRAND;
  if (d.brand_slug && BRANDS[d.brand_slug]) return d.brand_slug;
  return d.entity_type === "city_council" ? "citywatch" : DEFAULT_BRAND;
}
